// NPM Imports
import React, { Fragment, Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CreatableSelect from "react-select/lib/Creatable";
import { Tooltip, Button, Input, Label } from "@revvsales/components";
import { cloneDeep } from "lodash";
// import { DropdownSelect } from "../../../commonComponents";

// Internal Imports
import { GlobalUtils } from "../../../utils";
import { DOCUMENTS } from "../../../constants";

// Destructuring
const { validateEmail } = GlobalUtils;
const { DOCUMENT_MODE, ESIGN_TYPE_CONFIG } = DOCUMENTS;

export default class SignatureContentHandling extends Component {
  constructor(props) {
    super(props);
    this.state = {
      draggableSection:
        props.signblockData.signer_config &&
        props.signblockData.signer_config.options
          ? props.signblockData.signer_config.options
          : props.signblockData,
      draggedOverID: null,
      draggedSection: null,
      // signerType: props.signblockData.signer_config.signature_type
      //   ? props.signblockData.signer_config.signature_type
      //   : "",
      firstName: "",
      lastName: "",
      emailExistsError: "",
    };
  }

  componentDidMount() {
    const { signblockData, showNameField } = this.props;
    if (
      signblockData &&
      (signblockData.first_name || signblockData.last_name)
    ) {
      this.setState({
        firstName: signblockData.first_name,
        lastName: signblockData.last_name,
      });
    } else if (showNameField && (signblockData.fName || signblockData.lName)) {
      this.setState({
        firstName: signblockData.fName || "",
        lastName: signblockData.lName || "",
      });
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps.signblockData.signer_config &&
      nextProps.signblockData.signer_config !== prevState.draggableSection
    ) {
      return {
        draggableSection: nextProps.signblockData.signer_config.options
          ? nextProps.signblockData.signer_config.options
          : nextProps.signblockData.signer_config,
      };
    }
    return null;
  }

  _dragStart = (event, dataIndex) => {
    event.dataTransfer.effectAllowed = "move";
    this.setState({ draggedSection: dataIndex });
  };

  _dragEnd = () => {
    this.setState({
      draggedOverID: null,
      draggedSection: null,
    });
  };

  _onDragEnter = event => {
    event.preventDefault();
  };

  _onDragLeave = event => {
    event.preventDefault();
  };

  _onDragOver = (event, dataIndex) => {
    event.preventDefault();
    if (this.state.draggedOverID !== dataIndex) {
      this.setState({ draggedOverID: dataIndex });
    }
  };

  _onDrop = event => {
    event.preventDefault();
    const { showNameField } = this.props;
    if (this.state.draggedSection === null || showNameField) {
      return;
    }
    const oldDraggableSection = cloneDeep(this.state.draggableSection);
    this.setState({
      draggableSection: this._moveArrayItemToNewIndex(),
      draggedOverID: null,
      draggedSection: null,
    });
    this.props.updateSignerConfig(
      this.props.signerIndex,
      this.state.draggableSection,
      undefined,
      oldDraggableSection,
    );
  };

  _moveArrayItemToNewIndex = () => {
    const { draggableSection, draggedOverID, draggedSection } = this.state;
    draggableSection.splice(
      draggedOverID,
      0,
      draggableSection.splice(draggedSection, 1)[0],
    );
    return draggableSection;
  };

  _checkboxHandling = (e, index) => {
    const { draggableSection } = this.state;
    const oldDraggableSection = cloneDeep(draggableSection);
    draggableSection[index].checked = e.target.checked;
    this.setState({
      draggableSection,
    });
    this.props.updateSignerConfig(
      this.props.signerIndex,
      draggableSection,
      true,
      oldDraggableSection,
    );
  };

  _handleUserOnSelect = e => {
    this.props.handleValue(e, this.props.signerIndex, "signerEmail");
    if (!e) {
      this.setState({
        firstName: "",
        lastName: "",
      });
    }
  };

  _getValue = data => {
    const returnValue = {
      label: "Enter signer email",
      value: "Enter signer email",
    };
    if (data) {
      returnValue.label = data;
      returnValue.value = data;
    }
    return returnValue;
  };

  _getType = data => {
    let returnType = {
      label: "Click to Sign",
      sublabel: "Signer's full name will be captured as the signature",
      value: "FULLNAME",
    };
    if (data.signature_type) {
      const signerType = JSON.parse(JSON.stringify(ESIGN_TYPE_CONFIG));
      returnType = signerType.find(item => item.value === data.signature_type);
    }
    return returnType;
  };

  _getDisableStatus = data => {
    let status = true;
    const { firstName, lastName } = this.state;
    if (
      data.signer_email &&
      validateEmail(data.signer_email) &&
      firstName &&
      lastName
    ) {
      status = false;
    }
    return status;
  };

  _getSignatureTypeOptions = () => {
    let signerType = [];
    signerType = JSON.parse(JSON.stringify(ESIGN_TYPE_CONFIG));
    signerType.forEach(data => {
      data.label = this._getHtmlLabel(data);
    });
    return signerType;
  };

  _getHtmlLabel = data => (
    <div className="">
      <div className="btn-send-heading">{data.label}</div>
      <div className="btn-send-desc">{data.sublabel}</div>
    </div>
  );

  _handleAddNewSigner = (e, signerIndex, signblockData) => {
    const {
      handleValue,
      addNewSignerToSignerOptions,
      addSignerDetails,
      signerOptions,
    } = this.props;
    const { firstName, lastName } = this.state;
    if (
      !signblockData.updateProcess &&
      signerOptions.findIndex(s => s.value === signblockData.signer_email) !==
        -1
    ) {
      // if email already exsts - set error message
      this._handleUserOnSelect(null);
      this.setState(
        {
          emailExistsError:
            "* This email has been added with a different name, please select from dropdown or change email address",
        },
        () => {
          setTimeout(() => {
            this.setState({
              emailExistsError: "",
            });
          }, 5000);
        },
      );
      return;
    }
    handleValue(e, signerIndex, "first_name", firstName);
    handleValue(e, signerIndex, "last_name", lastName);
    addNewSignerToSignerOptions(
      signblockData.signer_email,
      firstName,
      lastName,
    );
    Promise.resolve(1).then(() => {
      addSignerDetails(signerIndex);
    });
  };

  render() {
    const {
      signblockData,
      signerIndex,
      removeSigner,
      editProcessInternalUser,
      showRemoveIcon,
      editMode,
      showNameField,
      signerOptions,
      cancleUpdateDetails,
      mode,
      handleEsignTypeValue,
    } = this.props;
    const { firstName, lastName, emailExistsError } = this.state;
    return (
      <Fragment>
        <div className="signature-content-wrapper">
          <div className="signature-content-section">
            <div className="signer-layer">
              <span className={`signer-label signer-${signerIndex + 1}`}>
                Signer {signerIndex + 1}
              </span>
              {showRemoveIcon && (
                <Tooltip
                  placement="top"
                  overlay="Delete signer"
                  align={{
                    offset: [0, 3],
                  }}>
                  <span
                    className="btn-icon signer-trash-icon"
                    onKeyPress={() => {}}
                    role="button"
                    tabIndex="0"
                    onClick={() => removeSigner(signerIndex)}>
                    <FontAwesomeIcon icon={["far", "trash-alt"]} />
                  </span>
                </Tooltip>
              )}
            </div>
            <div className={`signer-search-checkbox signer-${signerIndex + 1}`}>
              <div className="signer-control-handling">
                {mode !== DOCUMENT_MODE.TEMPLATE && (
                  <Fragment>
                    {editMode ? (
                      <div className="verified-signer">
                        <div className="signer-editable-name">
                          {signblockData.signer_config.image_url && (
                            <span className="signer-user-pic">
                              <img
                                alt="Revv"
                                className="signer-img"
                                src={signblockData.signer_config.image_url}
                              />
                            </span>
                          )}
                          <div className="signer-editable-profile">
                            <span className="signer-title">{`${
                              signblockData.first_name
                            } ${signblockData.last_name}`}</span>
                            <span className="signer-editable-email">
                              {signblockData.signer_email}
                            </span>
                          </div>
                          <Tooltip
                            placement="top"
                            overlay="Edit contact"
                            align={{
                              offset: [0, 3],
                            }}>
                            <span
                              className="signer-edit-btn"
                              data-test="signer-edit-btn"
                              onKeyPress={() => {}}
                              role="button"
                              onClick={() => {
                                this.setState({
                                  firstName: signblockData.first_name,
                                  lastName: signblockData.last_name,
                                });
                                editProcessInternalUser(signerIndex);
                              }}
                              tabIndex="0">
                              <FontAwesomeIcon icon={["far", "edit"]} />
                            </span>
                          </Tooltip>
                        </div>
                      </div>
                    ) : (
                      <Fragment>
                        <Label htmlFor="signer-email">
                          <span className="signer-lable">Signer email</span>
                        </Label>
                        <div data-test="signer-email-input-box">
                          <CreatableSelect
                            isClearable={
                              this._getValue(signblockData.signer_email)
                                .value !== "Enter signer email"
                            }
                            formatCreateLabel={userInput =>
                              `+ Add "${userInput.toLowerCase()}"`
                            }
                            className={`signer-input-box ${
                              signblockData.notValid ||
                              (showNameField &&
                                !validateEmail(signblockData.signer_email))
                                ? "not-valid-email"
                                : ""
                            }`}
                            onChange={this._handleUserOnSelect}
                            options={signerOptions}
                            value={this._getValue(signblockData.signer_email)}
                            autoFocus={signerIndex === 0}
                            data-test="signer-email-input-box"
                          />
                        </div>
                        {/* <Select options={signblockData.signer_type_config} /> */}

                        {showNameField && (
                          <Fragment>
                            <Input
                              type="text"
                              className="signer-input-box"
                              value={firstName}
                              placeholder="First name"
                              data-test="signer-user-firstname"
                              onChange={e => {
                                this.setState({
                                  firstName: e.target.value,
                                });
                                this.props.handleValue(
                                  null,
                                  signerIndex,
                                  "fName",
                                  e.target.value,
                                );
                              }}
                              autoFocus
                            />
                            <Input
                              type="text"
                              className="signer-input-box"
                              value={lastName}
                              placeholder="Last name"
                              data-test="signer-user-lastname"
                              onChange={e => {
                                this.setState({
                                  lastName: e.target.value,
                                });
                                this.props.handleValue(
                                  null,
                                  signerIndex,
                                  "lName",
                                  e.target.value,
                                );
                              }}
                            />
                          </Fragment>
                        )}
                        {emailExistsError ? (
                          <div className="add-signer-details-error">
                            {emailExistsError}
                          </div>
                        ) : null}
                        <div className="add-signer-details-wrapper">
                          {showNameField && (
                            <Button
                              className={` ${
                                !signblockData.updateProcess
                                  ? "signer-add-button"
                                  : ""
                              }`}
                              data-test="add-signer-details"
                              disabled={this._getDisableStatus(signblockData)}
                              onClick={e =>
                                this._handleAddNewSigner(
                                  e,
                                  signerIndex,
                                  signblockData,
                                )
                              }>
                              <FontAwesomeIcon
                                icon={["far", "user"]}
                                className="signer-add-icon"
                              />
                              {signblockData.updateProcess
                                ? "Update"
                                : "Add new signer"}
                            </Button>
                          )}
                          {signblockData.updateProcess && (
                            <Button
                              className="revv-btn-secondary"
                              data-test="add-signer-cancel"
                              onClick={() => cancleUpdateDetails(signerIndex)}>
                              Cancel
                            </Button>
                          )}
                        </div>
                      </Fragment>
                    )}
                  </Fragment>
                )}
                {/* {mode !== DOCUMENT_MODE.TEMPLATE && ( */}
                <Fragment>
                  <Label htmlFor="signature-type">
                    <span className="signer-lable">Signature type</span>
                  </Label>
                  <CreatableSelect
                    isSearchable={false}
                    style={{
                      height: "40px",
                    }}
                    options={this._getSignatureTypeOptions()}
                    value={this._getType(signblockData.signer_config)}
                    onChange={event =>
                      handleEsignTypeValue(event.value, signerIndex)
                    }
                    data-test="signer-signature-type-input-box"
                  />
                </Fragment>
                {/* )} */}
                <div className="signer-field-box">
                  <span className="signature-field-lable">
                    Switch on additional fields you want visible along with the
                    signature tag on the document
                  </span>
                  <div className="signature-field-control">
                    {this.state.draggableSection.map((draggableData, index) => (
                      <div
                        id={index}
                        className={`signature-draggable-section ${
                          draggableData.label === "Signature"
                            ? "hide-signature-block-content"
                            : ""
                        } ${
                          showNameField
                            ? "signature-draggable-section-no-drop"
                            : "signature-draggable-section-move"
                        }`}
                        draggable={showNameField ? "false" : "true"}
                        onDragStart={e => this._dragStart(e, index)}
                        onDragEnd={e => this._dragEnd(e, index)}
                        onDragEnter={e => this._onDragEnter(e, index)}
                        onDragOver={e => this._onDragOver(e, index)}
                        onDrop={e => this._onDrop(e, index)}>
                        <span className="ic-drag-bars">
                          <FontAwesomeIcon
                            icon={["far", "bars"]}
                            data-id={index}
                            className=""
                          />
                        </span>
                        <span data-id={index} className="draggable-label">
                          {draggableData.label}
                        </span>
                        <span
                          className="draggable-check-box"
                          data-test="signature-property-toggle-btns">
                          <Input
                            checked={draggableData.checked === true}
                            data-test="input-revv-inp-checkbox-or-radio"
                            isSwitch
                            type="checkbox"
                            onChange={e => this._checkboxHandling(e, index)}
                            disabled={showNameField}
                          />
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DocumentComponents/SignatureListPane/SignatureContentHandling.js